/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-card-actions[_ngcontent-%COMP%]:not(.footer-actions){margin:0;padding:0}.password-reset-buttons[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}.password-reset-buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{flex:.49}.mat-form-field[_ngcontent-%COMP%]{width:100%;min-width:300px}"];
export { styles as styles };
